$(document).ready(function () {
  $("#read-full").on("click", "button", function () {
    $(".blog-article__inner-content").css("max-height", "none");
    $("#read-full").hide();
  });
});

new Swiper(".ent-slider", {
  slidesPerView: 1,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    enabled: false,
  },
  breakpoints: {
    720: {
      navigation: {
        enabled: true,
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});

new Swiper(".related-slider", {
  slidesPerView: 1,
  loop: true,
  pagination: {
    enabled: true,
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    720: {
      slidesPerView: 3,
      pagination: {
        enabled: false
      },
    },
  },
});

new Swiper(".ent-related-swiper", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  loop: false,
  speed: 500,
  lazy: true,
  spaceBetween: 30,
  navigation: {
    enabled: false
  },
  breakpoints: {
    1024: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      loopAddBlankSlides: false,
      loop: true,
      spaceBetween: false,
      navigation: {
        enabled: true,
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
    768: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      loop: false,
      spaceBetween: false,
      navigation: {
        enabled: true,
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});